import React, { useEffect, useState, useRef } from 'react';
const GHOST_MESSAGES = ["I don't know how to say this", 'Did that come out wrong?', 'This is eating me alive', 'I need to word this better', "That's not what I meant", 'Am I overthinking this?', 'I should rewrite this', 'I wish I said that better'];
type Bubble = {
  id: number;
  msg: string;
  x: number; // percentage along screen width
  duration: number; // ms
  side: 'left' | 'right';
  driftX: number; // px lateral drift over the rise
};
const FloatingBubbles = () => {
  const [bubbles, setBubbles] = useState<Bubble[]>([]);
  const nextId = useRef(0);
  const sideToggle = useRef<'left' | 'right'>('right');
  useEffect(() => {
    const spawn = () => {
      const id = nextId.current++;
      const msg = GHOST_MESSAGES[Math.floor(Math.random() * GHOST_MESSAGES.length)];
      // Alternate sides for balance — never two consecutive bubbles on the same side.
      const side: 'left' | 'right' = sideToggle.current === 'right' ? 'left' : 'right';
      sideToggle.current = side;
      // Outer-edge placement only — well away from centered hero content.
      const x = side === 'right' ? 86 + Math.random() * 12 : 2 + Math.random() * 12;
      const duration = 11000 + Math.random() * 5000; // 11–16s, slow & calm
      const driftX = (Math.random() * 30 - 15) * (side === 'right' ? -1 : 1); // gentle inward drift
      setBubbles(b => [...b.slice(-3), {
        id,
        msg,
        x,
        duration,
        side,
        driftX
      }]);
      setTimeout(() => {
        setBubbles(b => b.filter(bb => bb.id !== id));
      }, duration);
    };
    spawn();
    const t = setInterval(spawn, 4500);
    return () => clearInterval(t);
  }, []);
  return <div aria-hidden="true" style={{
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    overflow: 'hidden',
    zIndex: 1
  }} data-id="element-92">
      {bubbles.map(b => {
      const positionStyle = b.side === 'right' ? {
        right: `${Math.max(1, 100 - b.x)}%`
      } : {
        left: `${b.x}%`
      };
      return <div key={b.id} style={{
        position: 'absolute',
        ...positionStyle,
        bottom: '-80px',
        animation: `bubble-rise ${b.duration}ms cubic-bezier(0.25, 0.1, 0.3, 1) forwards`,
        opacity: 0,
        // CSS variable to allow lateral drift inside the keyframe
        ['--bubble-drift-x' as any]: `${b.driftX}px`
      }} data-id="element-93">
            <div style={{
          maxWidth: 210,
          padding: '12px 16px',
          background: 'rgba(253, 232, 223, 0.62)',
          border: '1px solid rgba(232, 123, 92, 0.18)',
          borderRadius: '20px',
          color: 'rgba(209, 106, 74, 0.82)',
          fontSize: 14.5,
          fontWeight: 500,
          lineHeight: 1.3,
          letterSpacing: '0.005em',
          fontFamily: 'Inter, sans-serif',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          boxShadow: '0 6px 22px -10px rgba(232, 123, 92, 0.18), 0 2px 4px -1px rgba(26, 31, 54, 0.04)',
          textAlign: b.side === 'right' ? 'right' : 'left'
        }} data-id="element-94">
              {b.msg}
            </div>
          </div>;
    })}
    </div>;
};
export default FloatingBubbles;